import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 734301 594957"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#2b2a29;stroke-width:20022.1}.fil0{fill:#1c1b17;fill-rule:nonzero}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M251558 457886h64861l-48163 72480-48183-72480z"
        className="fil0 "
      />
      <path
        d="M534070 559708c14386-3904 21504-8289 24807-13795 3414-5716 3884-14526 4305-25759 1261-33376 791-73901 310-114566-430-38272-881-76715 80-109511l341-11573 78827 321L362600 44659 88778 285275l62990 390 260 11553c691 32136 781 65533 871 98929 90 32937 180 65873 861 97889 861 12453 2543 25828 9140 37361 6307 10992 17509 21013 37591 28201l210183 531 3243-501c10402-1572 17569-2653 23146-6717 1441-1052 3453-2713 5386-5196 1732-2183 3413-4996 4665-8630V389740l50-520c430-9931-1372-16609-5026-20593-3544-3874-9530-5856-17439-6367l-118451-1051c-7738 330-14105 1702-18220 4755-3424 2533-5576 6948-5957 13936l-1791 77976h-23697l1792-79278c821-14826 6447-24937 15537-31685 8360-6207 19182-8880 31505-9390 40235 0 80539 1041 120774 1041 13975 911 25368 5296 33427 14075 7848 8590 11873 20703 11252 37101h30v152559l-511 1762c-2252 7748-5746 13765-9360 18330-3604 4575-7338 7699-10021 9661-10421 7588-19862 9010-33557 11082l-4505 691c-72210-311-144429-381-216639-541l-1732-601c-27541-9430-43188-23596-52298-39503-8980-15647-11172-32276-12183-47563v-550c-701-32126-791-65533-891-98920-70-29202-160-58384-651-86926l-102183-650L362430 13255c114907 98478 229784 196997 344691 295506l-120133-481c-580 29863-190 63541 200 97118 471 41065 951 81960-310 115587-551 14727-1261 26420-7668 37101-6518 10892-17860 18841-39003 24577l-6137-22955z"
        className="fil0 "
      />
    </g>
  </svg>
)
export default SvgComponent
